import {RouterModule, Routes} from '@angular/router';
import { AplicacionFormComponent } from './form/aplicacion-form.component';
import { AplicacionListComponent } from './list/aplicacion-list.component';
import {NgModule} from '@angular/core';

const routes: Routes = [
    {
        path: '',
        component: AplicacionListComponent,
        pathMatch: 'full'
    },
    {
        path: 'registrar',
        component: AplicacionFormComponent,
    },
    {
        path: 'modificar',
        component: AplicacionFormComponent,
    },
    {
        path: 'ver',
        component: AplicacionFormComponent,
      },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AplicacionRoutingModule {
}
